// @ts-nocheck

class TableScroll {
  constructor() {
    this.instances = [];
    this.activeInstance = null;
    this.dragStartX = 0;
    this.dragStartScrollLeft = 0;

    const wrappers = document.querySelectorAll('[data-table-scroll]');
    if (!wrappers.length) return;

    wrappers.forEach((wrapperEl) => this.setupInstance(wrapperEl));
    if (!this.instances.length) return;

    window.addEventListener('resize', () => this.updateAll());
    document.addEventListener('pointermove', (event) => this.onDragMove(event));
    document.addEventListener('pointerup', () => this.onDragEnd());
  }

  setupInstance(wrapperEl) {
    const contentEl = wrapperEl.querySelector('[data-table-scroll-content]') || wrapperEl;
    const scrollbarEl = wrapperEl.querySelector('[data-table-scrollbar]');
    const thumbEl = wrapperEl.querySelector('[data-table-scroll-thumb]');
    if (!scrollbarEl || !thumbEl) return;

    const instance = { contentEl, scrollbarEl, thumbEl, scrollerEl: null };
    this.instances.push(instance);

    const resizeObserver = new ResizeObserver(() => this.update(instance));
    resizeObserver.observe(contentEl);

    const hideableEl = wrapperEl.closest('[data-slide-modal], [data-pdp-panel]');
    if (hideableEl) {
      const hideObserver = new MutationObserver(() => {
        if (!hideableEl.hasAttribute('hidden')) requestAnimationFrame(() => this.update(instance));
      });
      hideObserver.observe(hideableEl, { attributes: true, attributeFilter: ['hidden'] });
    }

    thumbEl.addEventListener('pointerdown', (event) => this.onDragStart(event, instance));

    this.update(instance);
  }

  bindScroller(instance) {
    const scroller = instance.contentEl.querySelector('.rte-table') || instance.contentEl;
    if (scroller === instance.scrollerEl) return;
    instance.scrollerEl = scroller;
    scroller.addEventListener('scroll', () => this.updateThumbPosition(instance));
  }

  updateAll() {
    this.instances.forEach((instance) => this.update(instance));
  }

  update(instance) {
    this.bindScroller(instance);
    const isOverflowing = instance.scrollerEl.scrollWidth > instance.scrollerEl.clientWidth + 1;
    if (!isOverflowing) {
      instance.scrollbarEl.setAttribute('hidden', '');
      return;
    }
    instance.scrollbarEl.removeAttribute('hidden');
    this.updateThumbSize(instance);
    this.updateThumbPosition(instance);
  }

  updateThumbSize(instance) {
    const ratio = instance.scrollerEl.clientWidth / instance.scrollerEl.scrollWidth;
    instance.thumbEl.style.width = ratio * 100 + '%';
  }

  updateThumbPosition(instance) {
    const maxScroll = instance.scrollerEl.scrollWidth - instance.scrollerEl.clientWidth;
    if (maxScroll <= 0) return;
    const travel = instance.scrollbarEl.clientWidth - instance.thumbEl.offsetWidth;
    const left = (instance.scrollerEl.scrollLeft / maxScroll) * travel;
    instance.thumbEl.style.transform = 'translateX(' + left + 'px)';
  }

  onDragStart(event, instance) {
    this.activeInstance = instance;
    this.dragStartX = event.clientX;
    this.dragStartScrollLeft = instance.scrollerEl.scrollLeft;
    event.preventDefault();
  }

  onDragMove(event) {
    if (!this.activeInstance) return;
    const instance = this.activeInstance;
    const maxScroll = instance.scrollerEl.scrollWidth - instance.scrollerEl.clientWidth;
    const travel = instance.scrollbarEl.clientWidth - instance.thumbEl.offsetWidth;
    if (travel <= 0) return;
    const delta = event.clientX - this.dragStartX;
    instance.scrollerEl.scrollLeft = this.dragStartScrollLeft + (delta / travel) * maxScroll;
  }

  onDragEnd() {
    this.activeInstance = null;
  }
}

new TableScroll();
